import React, { useState } from 'react';
import i18next from 'core/i18n';
import { IconButton } from '@indigo-ag/component-module';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';

import {
  BackgroundCheckModalIbama,
  BackgroundCheckModalIbamaProps
} from './components/BackgroundCheckModalIbama/BackgroundCheckModalIbama';
import { IIbamaInfo, evaluationTypesOptions, DocumentsList, PhaseSection } from 'shared';
import { SingleRow } from '../../SingleRow';

interface IbamaProps {
  ibamaInfo?: IIbamaInfo;
  disabled?: boolean;
  updateActions?: Pick<BackgroundCheckModalIbamaProps, 'onSave' | 'toUploadFiles'>;
}

export const Ibama: React.FunctionComponent<IbamaProps> = ({ ibamaInfo, updateActions, disabled }) => {
  /**
   * State
   */
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  const openIbamaModal = () => {
    setModalOpen(true);
  };

  const ibamaEvaluationTranslated = ibamaInfo?.ibamaEvaluation
    ? evaluationTypesOptions.find(e => e.value === ibamaInfo.ibamaEvaluation)?.name
    : '-';

  return (
    <>
      <PhaseSection
        title="Ibama"
        topRightContent={updateActions && <IconButton icon={faEdit} disabled={disabled} onClick={openIbamaModal} />}
      >
        {ibamaInfo?.ibamaEvaluation ? (
          <SingleRow title={i18next.t('evaluation')} content={ibamaEvaluationTranslated} />
        ) : null}

        {ibamaInfo?.ibamaNotes?.length ? (
          <SingleRow title={i18next.t('notes')} content={ibamaInfo?.ibamaNotes} />
        ) : null}
        {ibamaInfo?.ibamaFiles?.length ? (
          <SingleRow title={i18next.t('documents')}>
            <DocumentsList documents={ibamaInfo?.ibamaFiles || []} isVisible={true} />
          </SingleRow>
        ) : null}
      </PhaseSection>

      {updateActions ? (
        <BackgroundCheckModalIbama
          ibamaInfo={ibamaInfo}
          closeModal={closeModal}
          open={modalOpen}
          onSave={updateActions.onSave}
          toUploadFiles={updateActions.toUploadFiles}
        />
      ) : null}
    </>
  );
};
